export default {
    'cart.global.withDph': 'z VAT',

    'product.showMoreBtn': 'Pokaż więcej',
    'product.cartBtn': 'Dodaj',

    'contact.phoneNumber': '+48 33 300 32 21',
    'contact.email': 'info@swietneceny.pl',
    'contact.openingHours': 'Pon.-pt. 7:00 - 14:00',

    'newsletter.title': 'Otrzymuj korzyści jako pierwszy!',
    'newsletter.btn': 'Zapisz się do newslettera',

    'input.emailPlaceholder': 'Twój e-mail',

    'header.mobileMenuHeading': 'Kategorie główne',
    'header.otherCategories': 'Inne',

    'category.loading': 'Pokaż więcej',
    'category.availability': 'W magazynie',

    'detail.brand': 'Producent',
    'detail.expirationDate': 'Data ważności',

    'login.title': 'Zaloguj się do konta',

    'cart.showCart': 'Koszyk',

    'advancedOrder.productsHeader': 'Inni kupili również',

    'cart.step1.next': 'Wybierz dostawę i płatność',
    'cart.step1.addCoupon': 'Dodaj',
    'cart.step1.addCouponTitle': 'Kupon rabatowy',
    'cart.step1.gift': 'Prezent',
    'cart.step1.giftFree': 'Prezent zdarma!',

    'cart.step2.nextStepBtn': 'Uzupełnij swoje dane',
    'cart.step3.loginLink': 'Zaloguj się',

    'cart.thankYouPage.heading': 'Twoje zamówienie zostało złożone!',
    'cart.thankYouPage.thankYouOrderNumber': 'Dziękujemy za numer zamówienia',
    'cart.thankYouPage.orderNumber': 'Numer zamówienia',

    'cart.emptyCart.backToShop': 'Wróć do sklepu',
    'cart.emptyCart.emptyCart': 'Twój koszyk jest pusty',
    'cart.emptyCart.emptyCartSubtitle':
        'Twój koszyk czeka na swoje pierwsze odkrycia – sprawdź naszą ofertę!',

    'cart.step1.orderSummary': 'Podsumowanie zamówienia',

    'contact.title': 'Skontaktuj się z nami',

    'reviews.name': 'Zweryfikowany klient',
    'reviews.name': 'Zweryfikowany klient',

    'terms.text':
        '<a href="/regulamin/">Regulamin</a> i <a href="/polityka-prywatnosci/">Polityka prywatności</a>',
}
